/**
 * Every localStorage key the app owns. Logout clears storage, so anything that
 * must survive it has to be listed in `PRESERVE_ON_LOGOUT`.
 */
export const LOCAL_STORAGE_KEYS = {
  /** Web3Auth idToken — sent as `Authorization: Bearer` to `server/`. */
  ACCESS_TOKEN: "kf_access_token",
  /** Last locale the visitor chose. */
  LOCALE: "kf_locale",
} as const;

export type LocalStorageKey =
  (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS];

export const PRESERVE_ON_LOGOUT: readonly string[] = [
  LOCAL_STORAGE_KEYS.LOCALE,
];
